<template>
  <div class="about">
      <header style="background: rgb(247, 250, 252)">
          <container class="py-8 md:py-16">
            <div style="max-width: 720px" class="mx-auto">
              <ul class="breadcrumbs flex mb-4">
                <li><router-link to="/" class="text-awro-700" >{{$t('nav.home')}}</router-link></li>
                <li class="mx-1">/</li>
                <li><router-link to="/about"  class="text-awro-700" active-class="router-active">{{$t('nav.about')}}</router-link></li>
              </ul>
              <head-line :level="1" :size="1" :bold="true">{{ $t('nav.about') }}</head-line>
              <p class="subtitle text-muted mt-2">{{ $t('slugan') }}</p>
            </div>
          </container>
      </header>


      <container>
        <div style="max-width: 720px" class="mx-auto">
          <div class="card bg-white leading-relaxed lg:rounded-lg lg:shadow-lg py-5 lg:p-5 lg:p-6 lg:mb-8  lg:-mt-6 text-lg" v-html="$t('pages.about.content.copy')">
          </div>
          <section class="my-12">
            <head-line :level="4" :size="4" :bold="true">{{ $t('pages.about.content.features-headline') }}</head-line>
            <ul class="mt-4 text-lg leading-relaxed">
              <li class="py-4" v-for="(feature, index) in $t('pages.about.content.features')" :key="index">
                <p class="font-bold">{{ feature.title }}</p>
                <p>{{ feature.body }}</p>
              </li>
            </ul>
          </section>


        </div>
        <hr>
      </container>

</div>
</template>
<script>
import Container from '@/components/Container';
import HeadLine from '@/components/theme/HeadLine'
import {mapGetters} from 'vuex'

export default {
 name: 'About',
  components: {
    Container,
    HeadLine
  },
  computed: {
    ...mapGetters({
      isRtl: ['locale/IS_RTL']
    })
  },
  metaInfo() {
    return {
      title: this.$i18n.t('awronore') + ' | ' + this.$i18n.t('pages.about.title'),
      htmlAttrs: {
        amp: true,
        lang: this.$i18n.locale
      },
      meta: [
        {name:"developed-by", content: "Shahram Mebashar Hassan"}
      ] 
    } 
  }
}
</script>
